import Vue from "vue";
import { Component } from "vue-property-decorator";

import { SelectOption } from "../../logic/types";

type CurrencyType = "RUB" | "USD" | "EUR" | "XTR" | string

@Component
export default class CurrenciesHelperMixin extends Vue {
  currencyOptions(currencies: Array<SelectOption>): Array<SelectOption> {
    return currencies.map(c => {
      return {
        value: c.value,
        label: this.getCurrencyLabel(c.value)
      }
    })
  }

  getCurrencyLabel(value: CurrencyType) {
    if (value === "XTR") {
      return this.$t('currencies_xtr_title').toString()
    }

    return value
  }
}
